// eslint-disable-next-line import/no-cycle
import {
  selectionBasedIDLogicalOperators,
  stringLogicalOperators,
} from '@/composables/segmentations/logicalOperators';

/**
 * Get the current category properties segments for navigation context
 * These segments are evaluated against the current page's category context
 */
export const getCurrentCategoryPropertiesSegments = (includeContext = false) => [
  {
    id: 'id',
    label: 'segmentations.navigation.currentCategory.id',
    logical_operators: selectionBasedIDLogicalOperators('id'),
    ...(includeContext && { context: 'navigation.currentCategory.id' }),
  },
  {
    id: 'name',
    label: 'segmentations.navigation.currentCategory.name',
    logical_operators: stringLogicalOperators('name'),
    ...(includeContext && { context: 'navigation.currentCategory.name' }),
  },
];

export default getCurrentCategoryPropertiesSegments;
